export default {
  methods: {
    // Method for constructing error message
    constructErrorMessage(error) {
      // console.log("==== Construct error ==============");
      // console.log("error:", error);

      const combinedErrors = [];
      if (error.response) {
        if (error.response.data) {
          //console.log("error.response.data:", error.response.data);
          if (error.response.data.errors) {
            // console.log("entered errors");
            //const errorMessage = error.response.data.message;
            const errors = error.response.data.errors;

            //console.log("errorMessage: ", errorMessage);
            // console.log("errors: ", errors);

            // Push the main error message at the beginning if it exists
            //if (errorMessage) combinedErrors.push(errorMessage);

            // Loop through the errors object if it exists
            if (errors) {
              // console.log("construct -> errors: ", errors);
              for (const field in errors) {
                if (errors.hasOwnProperty(field)) {
                  // console.log("errors[field]:", errors[field]);
                  errors[field].forEach((error) => {
                    //console.log("errorMessage: ", error);
                    const translatedMessage = this.$t(error.trim()); // Remove leading and trailing whitespaces from the error string with trim()
                    //console.log("translatedMessage: ", translatedMessage);
                    // Push the translated error message to the combinedErrors array
                    combinedErrors.push(translatedMessage);
                  });
                  // console.log("combinedErrors: ", combinedErrors);
                }
              }
            }
          } else if (arguments[0].response.data.error) {
            //console.log("error global:", arguments[0]);
            //console.log("entered error");
            const errorMsg = arguments[0].response.data.error;
            //console.log("***errorMsg: ", error);
            const translatedMessage = this.$t(errorMsg);
            combinedErrors.push(translatedMessage);
          }
        }
      }
      let combinedErrorsMessage = "";
      if (combinedErrors.length > 0) {
        // Combine all error messages into one string with line breaks
        combinedErrorsMessage = combinedErrors.join("<br><br>");
        //console.log("combinedErrorsMessage: ", combinedErrorsMessage);
      } else {
        // Default error message
        combinedErrorsMessage = this.$t("error_try_again_later");
      }

      return combinedErrorsMessage;
    },
  },
};
